import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SharedTabItem } from './shared-tabs.interfaces';

@Component({
  selector: 'tablesready-shared-tabs',
  templateUrl: './shared-tabs.component.html',
  styleUrls: ['./shared-tabs.component.scss'],
})
export class SharedTabsComponent implements OnInit {
  @Input() tabIndex = 0;
  @Input() items: SharedTabItem[] = [];
  @Input() showBorders = true;
  @Input() disabled = false;
  @Output() tabChange = new EventEmitter<number>();

  ngOnInit(): void {}
}
